<script>
  import ArrowLink from "../components/Common/ArrowLink.svelte";
  import Header from "../components/Common/Header.svelte";
  import SearchResults from "../components/Reports/Results/SearchResults.svelte";
  import TopSearch from "../components/Reports/Results/TopSearch.svelte";
</script>

<Header>
  <ArrowLink href="/reports" routing={true} text="Reports" />
  <h1>Search Reports</h1>
</Header>
<TopSearch />
<SearchResults />
